import React, {useMemo} from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import {makeStyles} from "@material-ui/core/styles"
import {useTranslation} from "react-i18next"
import {useStore} from "../Store"

const ABOUT_URL = process.env.ABOUT_URL
const COMPANY = process.env.COMPANY
const CONTACT_URL = process.env.CONTACT_URL
const COPYRIGHT = process.env.COPYRIGHT
const POLICY_URL = process.env.POLICY_URL
const TERMS_URL = process.env.TERMS_URL

const useStyles = makeStyles((theme) => ({
  root: {
    width: `85%`,
    margin: `0px auto 0px`,
    textAlign: `center`,
    padding: `16px 0px 0px`,
  },
  link: {
    color: theme.palette.primary.contrastText,
    textDecoration: `none`,
  },
  label: {
    display: `block`,
    margin: 8,
  },
  labelCopyright: {
    display: `block`,
    margin: `8px 8px 0 8px`,
  },
}))

export default function FooterEx() {
  const {t} = useTranslation()
  const classes = useStyles()
  const {
    store: {themeColor, locale},
  } = useStore()

  return useMemo(
    () => (
      <div className={classes.root}>
        <Grid container justify={`center`} spacing={2}>
          <Grid item xs={12} sm={2}>
            <Typography align={`center`} gutterBottom color={`textSecondary`}>
              <a href={ABOUT_URL} target={`_blank`} className={classes.link}>
                {t(`help`)}
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography align={`center`} gutterBottom color={`textSecondary`}>
              <a href={POLICY_URL} target={`_blank`} className={classes.link}>
                {t(`privacy`)}
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography align={`center`} gutterBottom color={`textSecondary`}>
              <a href={TERMS_URL} target={`_blank`} className={classes.link}>
                {t(`terms`)}
              </a>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography align={`center`} gutterBottom color={`textSecondary`}>
              <a href={CONTACT_URL} target={`_blank`} className={classes.link}>
                {t(`contact`)}
              </a>
            </Typography>
          </Grid>
        </Grid>
        <Typography variant={`caption`} align={`center`} className={classes.label}>
          {COMPANY}
        </Typography>
        <Typography variant={`caption`} align={`center`} className={classes.labelCopyright}>
          {COPYRIGHT}
        </Typography>
      </div>
    ),
    [classes, themeColor, locale],
  )
}
